module.exports = __webpack_public_path__ + "media/src/images/icon/tab-25caa10cbaaa747378ee0a9a41896fd8.svg";